import React, { useEffect, useState } from "react";
import { FlexContainer, MedCol50 } from "../common/Flex";
import { ControlBox, ControlBoxHeader, ControlBoxLabel } from "../common/ControlBox";
import CheckboxOption from "./CheckboxOption";
import styled from "styled-components";
import api from '../../utils/api';

interface JargonStatusProps {
    show: boolean;
    hasEverShown: boolean;
}

const JargonStatusContainer = styled.div<{show: boolean, hasEverShown: boolean}>`
    color:var(--jargon-primary);
    font-style:italic;
    font-weight:800;
    font-size:1.25rem;
    opacity: ${props => props.show ? 1 : 0};
    display: ${props => props.hasEverShown ? 'block' : 'none'};
    transition: opacity var(--fade-duration) ease-in-out;
    margin-bottom: var(--vertical-spacing);
    width: 100%;
`;

export const JargonStatus : React.FC<JargonStatusProps> = ({ show, hasEverShown }) => {
    return(
        <JargonStatusContainer show={show} hasEverShown={hasEverShown}>
            <p>Processing...</p>
        </JargonStatusContainer>  
    );
}